import React from 'react';

export default function Loading({ children }) {
	return (<main className="flex flex-grow bg-hub-grey">
		<div className="flex container bg-white mx-auto shadow-lg p-12 mx-3 sm:mx-auto text-center">
			<h1 className="text-4xl font-medium mx-auto"><span className="spinner h-full w-20 inline-block" />&nbsp;{ children }</h1>
		</div>
	</main>);
}